import { EmailSettingPage } from "@/features/system-setting/pages/EmailSetting";

const EmailSetting = () => {
  return <EmailSettingPage />;
};

export default EmailSetting;
